







import { Component, Vue, Prop } from 'vue-property-decorator';
import IconSoldOut from '@/components/icons/IconSoldOut.vue';
import IconStopSale from '@/components/icons/IconStopSale.vue';
import EditRoomStatus from '@/components/dropdowns/EditRoomStatus.vue';
import { mapState } from 'vuex';
import moment from 'moment';

@Component({
  components: {IconSoldOut, IconStopSale},
  computed: mapState({
    dropdown: (state: any) => state.dashboard.dropdownRoomStatus,
    isOnRequest: (state: any) => state.dashboard.isOnRequest,
  }),
})
export default class BoxRoomStatus extends Vue {
  @Prop({ required: true }) public readonly type!: string;
  @Prop({ required: true }) public readonly quantity!: number;
  @Prop({ required: true }) public readonly roomId!: string;
  @Prop({ required: true }) public readonly date!: string;
  @Prop({ required: true }) public readonly stopSaleReason!: string;
  @Prop({ required: true }) public readonly isVariablePricingEnabled!: boolean;
  @Prop({ required: true }) public readonly hasVariablePricing!: boolean;


  public dropdown: any;

  get isLoading() {
    return this.dropdown && this.dropdown.isLoading && (this.dropdown.id === `${this.roomId}${this.date}`);
  }

  get statusClass() {
    if (this.isLoading) {
      return '';
    }
    if (this.type === 'R') {
      return 'open';
    }
    if (this.type === 'I') {
      if (!this.quantity && this.isVariablePricingEnabled) {
        return 'so-vp';
      } else if (!this.isVariablePricingEnabled) {
        return 'so';
      }
      return 'open';
    }
    if (this.type === 'U') {
      return 'stop';
    }

  }

  get variablePricingClass() {
    return (this.isVariablePricingEnabled && this.hasVariablePricing) ? 'variable-pricing' : '';
  }

  get activeClass() {
    return this.dropdown
      && this.dropdown.date
      && this.dropdown.date === this.date
      && this.dropdown.id === `${this.roomId}${this.date}` ? 'active' : '';
  }

  get isSaturday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '6';
  }

  get isMonday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '1';
  }

  public toggleDropdown() {
    if (this.dropdown && this.dropdown.id === `${this.roomId}${this.date}`) {
      this.$dropdown.hide();
    } else {
      this.showPopup();
    }
  }

  private showPopup() {
    const wrapperEl = this.$refs.boxRoomStatus as any;
    if (!wrapperEl) {
      return;
    }
    this.$store.commit('setDropdownRoomStatus', {
      component: EditRoomStatus,
      isLoading: false,
      show: true,
      x: wrapperEl.offsetParent.offsetLeft + wrapperEl.offsetLeft + wrapperEl.offsetWidth / 2,
      y: wrapperEl.offsetParent.offsetTop + 45 + 5, // 45 is box height, 5 is extra space for arrow
      data: {
        id: `${this.roomId}${this.date}`,
        type: this.type,
        quantity: this.quantity,
        roomId: this.roomId,
        date: this.date,
        stopSaleReason: this.stopSaleReason,
      },
    });
  }
}
